<script lang="ts" setup>
import { Breadcrumb } from '@/page/domain/Breadcrumb';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getBaseUrl } = useUrlHelper();

withDefaults(defineProps<{
  breadcrumbs: Array<Breadcrumb>,
  linkClass?: string
}>(), {
  linkClass: 'text-blue-500 hover:text-blue-700'
});

</script>
<template>
  <div class="flex flex-row py-2 breadcrumb">
    <div v-for="(breadcrumb, index) in breadcrumbs" :key="index">
      <a :href="getBaseUrl(breadcrumb.href)" v-if="index !== breadcrumbs.length - 1" class="cursor-pointer" :class="linkClass">
        {{ breadcrumb.label }}
      </a>
      <span v-else>{{ breadcrumb.label }}</span>
      <span v-if="index < breadcrumbs.length - 1" class="mx-2"> > </span>
    </div>
  </div>
</template>
